<template>
    <div class="container-fluid">
        <br>
        <a @click="$router.go(-1)" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{ $t('words.cancel') }}
        </a>
        <button type="button" :disabled="loading" @click="saveData()" class="btn btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <br>
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" class="nav-item">
                            <a class="nav-link active"> <i class="fa fa-tag"></i>
                                Dados do Termo</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Tab panes -->
            <div class="card-body">
                <div class="tab-content">
                    <div class="tab-pane active" id="tabFormulario">
                        <span v-html="$t('validation.field_required')"></span>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <required /> <label  :class="{'text-danger': errors.has('Data')}">{{ $t('attributes.date') }}</label>
                                    <input name="Data" :class="{'is-invalid': errors.has('Data')}" v-validate="{required: true}" v-model="termo.termo_data" required
                                        type="date" class="form-control">
                                    <div class="invalid-feedback help-block error">{{errors.first('Data')}}</div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="form-group">
                                    <required /> <label  :class="{'text-danger': errors.has('description')}">{{ $t('words.description') }}</label>
                                    <input name="description" :class="{'is-invalid': errors.has('description')}" v-validate="{required: true, max:191}"
                                        v-bind:placeholder="$t('words.type_description')"
                                        v-model="termo.termo_descricao" type="text" class="form-control">
                                    <div class="invalid-feedback help-block error">{{errors.first('description')}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <required /><label  :class="{'text-danger': errors.has('conteudo')}">Conteúdo</label>
                                    <wysiwyg :class="{'is-invalid': errors.has('conteudo')}" v-validate="{required: true}" :name="'conteudo'"
                                        v-model="termo.termo_conteudo" />
                                    <div class="invalid-feedback help-block error">{{errors.first('description')}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                termo: {}
            }
        },
        mounted() {
            if (this.$route.name !== 'termoCreate') {
                this.getTermoById();
            }
        },
        methods: {
            saveData() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.$route.name == 'termoCreate' ? this.store() : this.update();
                    }
                });
            },
            getTermoById() {
                this.$store
                    .dispatch('getTermoById', this.$route.params.id)
                    .then(response => {
                        this.termo = response;
                    });
            },
            store() {
                this.loading = true;
                this.$store.dispatch('storeTermo', this.termo).then(response => {
                    this.loading = false;
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                });
            },
            update() {
                this.loading = true;
                this.$store.dispatch('updateTermo', this.termo).then(response => {
                    this.loading = false;
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                    this.$router.go(-1);
                });
            }
        }
    };
</script>